import { NO_CREATION_DATE_FILTER } from "ui/model"
import { IMediaState, ISspMediaApprovalFilters } from "../model"

export function getDefaultMediaState(): IMediaState {
  return {
    mediaTypes: [],
    sspMediaApproval: {
      mediaApprovalsData: [],
      filteredMediaApprovalsData: [],
      isLoading: false,
      hasError: false,
      isFilterExpanded: true,
      isUpdating: false,
      filters: getDefaultMediaApprovalFilters()
    }
  }
}

export function getDefaultMediaApprovalFilters(): ISspMediaApprovalFilters {
  return {
    name: "",
    approvalStatuses: [],
    languages: [],
    createdAt: NO_CREATION_DATE_FILTER
  }
}
